module.exports = __webpack_public_path__ + "21c7c041eb097f123f156de99d9267fe.svg";